/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import LocationPinRegular from './location-pin-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <LocationPinRegular {...validProps} />;
}

SvgComponent.iconName = 'locationPinRegular';

export const LocationPinRegularIcon = svgIconWrapper(SvgComponent);
